let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hJJuC")).then(() => parcelRequire('7TH4E'));